var map = {
	"./1.jpg": "6734",
	"./2.jpg": "3898",
	"./3.jpg": "13a7",
	"./steak-1.png": "0136",
	"./steak-2.png": "036e",
	"./steak-3.png": "8989"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6dfe";